const SUPPORT_EMAIL = "raghav@nutrisaathi.life";

export default function SupportButton() {
  return (
    <a
      href={`mailto:${SUPPORT_EMAIL}?subject=NutriSaathi Support Request`}
      title="Contact Support"
      className="support-button"
      aria-label="Contact Support"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="10" />
        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
        <path d="M12 17h.01" />
      </svg>
      <span>Support</span>
    </a>
  );
}
